import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FaBuilding, FaCheck, FaChevronDown, FaChevronRight, FaFileExcel, FaFilePdf, FaHashtag, FaLink, FaLock, FaPaperPlane, FaPlane, FaSave, FaSearch, FaTrash, FaUpload, FaUserCheck, FaUserMinus } from 'react-icons/fa';
import { toast } from 'react-toastify';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import ErpTemplate from '../../components/ErpTemplate';
import CabecalhoEventoAereo from '../../components/CabecalhoEventoAereo';
import ConfirmarAcaoModal from '../../components/ConfirmarAcaoModal';
import { useAtendimentoAereo } from '../../components/AtendimentoAereo';
import { FinCheck, FinChecks, FinField, FinInput, FinNumber, FinTextarea, FinValor } from '../../components/FinField';
import ReactSelect from '../../components/ReactSelect';
import UploadDropzone from '../../components/UploadDropzone';
import PlanilhaEmissaoAereo, {
    AbasDaPlanilha, BadgeConsolidado, CamposAGravar, ChipsLegenda, ConsolidadoPlanilha, chaveDaAba, ehDaTodos, FILTRO_VOO_VAZIO, FiltroVoo, NovaAba, PillLegenda, filtrosSemEquivalente, passaNosFiltros, ROTULOS_SEM_OBSERVACAO, SelectOrigem, SelectRequisicao, canceladaNaTela, filtroVooAtivo, prontoParaGravar, resumoFiltroVoo, retidoPeloVooTrocado, TRECHOS_EMISSAO as TRECHOS, TotaisPlanilha, baixarBlob, dataHora, entradasDe, eticketFormatado,
    CAMPOS_PREVISTOS, ladosEmCustos, brl,
} from '../../components/PlanilhaEmissaoAereo';
import api from '../../services/api';
import notify from '../../services/notify';
import { useSetFullBreadcrumbTrail } from '../../context/BreadcrumbContext';
import '../../css/financeiro-parcela-pagar.css';

const API = process.env.REACT_APP_API_URL;

const ROTULO_TRECHO = Object.fromEntries(TRECHOS);
const opcoesSelect = (pares) => pares.map(([value, label]) => ({ value, label }));

const LADOS_CONFLITO = [['ida', 'a Ida'], ['retorno', 'o Retorno']];

// Conflito é dois bilhetes para o mesmo lado: dois prontos, ou um pronto sobre um lado que já tem bilhete
// gravado. É aviso, não trava: a gravação segue a ordem de subida, e o último fica no cadastro. Ida num
// bilhete e volta noutro é complemento, e não aparece aqui.
const conflitosDoGrupo = (g) => LADOS_CONFLITO.flatMap(([lado, rotulo]) => {
    const n = g.bilhetes.filter(b => b.trecho === lado || b.trecho === 'ida_volta').length;
    if (n > 1) return [`Dois bilhetes para ${rotulo}: o que subiu por último fica no cadastro.`];
    if (n === 1 && g.ladosEmitidos?.[lado]) return [`${rotulo.charAt(0).toUpperCase()}${rotulo.slice(1)} já tem bilhete gravado: o novo substitui o anterior no cadastro.`];
    return [];
});

// Revisão da gravação: os bilhetes que o Enviar para o RSVP vai gravar, agrupados por participante, em
// acordeão. Não há o que marcar — todo bilhete pronto vai. Participante com divergência abre já expandido.
function RevisaoGravacao({ bilhetes }) {
    const grupos = useMemo(() => {
        const mapa = new Map();
        bilhetes.forEach(b => {
            const chave = b.participante?.id ?? b.emissao ?? b.id;
            if (!mapa.has(chave)) mapa.set(chave, { chave, nome: b.participante?.nome ?? '—', ladosEmitidos: b.participante?.ladosEmitidos ?? {}, bilhetes: [] });
            mapa.get(chave).bilhetes.push(b);
        });
        return [...mapa.values()].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    }, [bilhetes]);
    const [abertos, setAbertos] = useState(() => new Set(grupos
        .filter(g => grupos.length === 1 || g.bilhetes.some(b => (b.divergencias ?? []).length))
        .map(g => g.chave)));
    const alternarGrupo = (chave) => setAbertos(prev => {
        const novo = new Set(prev);
        if (novo.has(chave)) novo.delete(chave); else novo.add(chave);
        return novo;
    });
    const todosAbertos = grupos.length > 0 && grupos.every(g => abertos.has(g.chave));

    return (
        <>
            <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                <span className="fin-pp__cell-muted">
                    {bilhetes.length} bilhete{bilhetes.length !== 1 ? 's' : ''} em {grupos.length} participante{grupos.length !== 1 ? 's' : ''}
                </span>
                <button type="button" className="fin-pp__linkbtn"
                    onClick={() => setAbertos(todosAbertos ? new Set() : new Set(grupos.map(g => g.chave)))}>
                    {todosAbertos ? 'Recolher todos' : 'Expandir todos'}
                </button>
            </div>
            <div className="fin-pp__groups">
                {grupos.map(g => {
                    const aberto = abertos.has(g.chave);
                    const divergente = g.bilhetes.some(b => (b.divergencias ?? []).length);
                    const conflitos = conflitosDoGrupo(g);
                    return (
                        <div key={g.chave} className="fin-pp__grp">
                            <div className="fin-pp__grp-head" onClick={() => alternarGrupo(g.chave)}>
                                <span className="fin-pp__grp-caret">{aberto ? <FaChevronDown size={11} /> : <FaChevronRight size={11} />}</span>
                                <span className="fin-pp__grp-name">{g.nome}</span>
                                <span className="fin-pp__grp-badge">{g.bilhetes.length} bilhete{g.bilhetes.length !== 1 ? 's' : ''}</span>
                                {divergente && <span className="fin-pp__pill is-warn">Com divergência</span>}
                                {conflitos.length > 0 && <span className="fin-pp__pill is-warn" title={conflitos.join(' ')}>Conflito</span>}
                            </div>
                            {aberto && conflitos.map((t, k) => (
                                <div key={k} style={{ padding: '8px 16px 0' }}><span className="fin-pp__pill is-warn" style={{ whiteSpace: 'normal' }}>{t}</span></div>
                            ))}
                            {aberto && g.bilhetes.map((b, i) => {
                                const d = b.dados ?? {};
                                return (
                                    <div key={b.id} style={{ padding: '12px 16px', borderTop: i ? '1px solid var(--fin-bd)' : undefined }}>
                                        <div className="d-flex align-items-center gap-2 flex-wrap" style={{ marginBottom: 8 }}>
                                            <span className="fin-pp__cell-strong">{ROTULO_TRECHO[b.trecho] ?? 'Trecho não identificado'}</span>
                                            <span className="fin-pp__cell-muted">
                                                {d.eticket ? `E-ticket ${eticketFormatado(d.eticket)}` : 'Sem número do bilhete'}{d.localizador ? ` · LOC ${d.localizador}` : ''}
                                            </span>
                                        </div>
                                        {(b.divergencias ?? []).map((t, k) => (
                                            <div key={k} style={{ marginBottom: 6 }}><span className="fin-pp__pill is-warn" style={{ whiteSpace: 'normal' }}>{t}</span></div>
                                        ))}
                                        <CamposAGravar campos={b.aplicar ?? []} gravado={b.situacao === 'gravado'} marcarDivergentes />
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </>
    );
}

// Spinner do `.fin-pp` no tamanho do ícone de botão.
const SpinnerBotao = () => (
    <span className="fin-pp__spinner" style={{ width: 11, height: 11, borderWidth: 2, margin: '0 5px 0 0', verticalAlign: '-1px' }} />
);

// Mesmo teto do back (`max:10240` no upload dos bilhetes).
const LIMITE_PDF = 10 * 1024 * 1024;
const chaveArquivo = (f) => [f.name, f.size, f.lastModified].join('|');
const tamanhoArquivo = (bytes) => bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
// O rascunho das abas da planilha sem nada: nenhuma nova, nenhuma saindo.
const ABAS_SEM_RASCUNHO = { novas: [], excluidas: [] };
// O tempo de voo da aba do lápis: vazio, ou HH:MM por voo separados por "|" (`tempoDeVooNormalizado` no back).
const tempoDeVooValido = (v) => /^\s*(\d{1,2}:[0-5]\d\s*(\|\s*\d{1,2}:[0-5]\d\s*)*)?$/.test(String(v ?? ''));

/**
 * O corpo do modal do lápis: as colunas editáveis da linha, uma aba por coluna. A Comunicação
 * Intermediária é um texto, sem autor nem data. Os assentos são o valor pago pela marcação de assento,
 * por lado, nas colunas ASSENTOS IDA e ASSENTOS VOLTA da planilha. O DBL CHECK são as conferências da
 * linha, cada uma com a data e quem marcou, travadas — conferência gravada não se desmarca —, e uma vazia
 * no fim para quem confere agora: de nenhuma a N. A Reserva é o valor prévio do lado em aprovação de custos
 * sem bilhete, o mesmo que o motivo pede (`reserva.lados`; sem lado, `reserva.motivo` diz por quê). O FEE é o FEE
 * por bilhete da Access na linha: vazio, vale o Padrão do cliente (`feePadrao`: { valor, origem }), e o "Aplicar em
 * todas" o leva às linhas que quem está na tela opera. Nada aqui vai ao banco: o Aplicar põe no rascunho da linha.
 * `form`: { aba, comunicacao, assentosIda, assentosVolta, conferir, tarifaPrevistaIda e afins, feeCliente, feeEmTodas }.
 */
function ColunasEditaveis({ linha, form, setForm, reserva, feePadrao }) {
    const gravadas = linha?.emissao?.dblCheck ?? [];
    const conferencias = gravadas.length + (form.conferir ? 1 : 0);
    const naAba = (aba) => setForm(f => ({ ...f, aba }));
    const aba = ['assentos', 'reserva', 'fee', 'tempo', 'dblcheck'].includes(form.aba) ? form.aba : 'comunicacao';
    const tempoDeVoo = (campo, rotulo) => (
        <FinField label={rotulo}>
            <FinInput value={form[campo] ?? ''} placeholder="01:05" style={{ paddingLeft: 14 }}
                onChange={ev => { const texto = ev.target.value; setForm(f => ({ ...f, [campo]: texto })); }} />
            {!tempoDeVooValido(form[campo]) && (
                <div style={{ fontSize: 12, color: 'var(--fin-dg)', marginTop: 4 }}>Use HH:MM, um por voo separados por |.</div>
            )}
        </FinField>
    );
    const padrao = feePadrao?.valor ?? null;
    const numTkt = Number(linha?.emissao?.numTkt) || 0;
    const porBilhete = form.feeCliente ?? padrao;
    const feeDaLinha = porBilhete !== null && numTkt > 0 ? porBilhete * numTkt : null;
    const assento = (campo, rotulo) => (
        <FinField label={rotulo}>
            <FinNumber prefix="R$ " placeholder="R$ 0,00" value={form[campo] ?? ''}
                onValueChange={({ floatValue }) => setForm(f => ({ ...f, [campo]: floatValue ?? null }))} />
        </FinField>
    );
    const valorPrevio = (campo, rotulo) => (
        <FinField key={campo} label={rotulo}>
            <FinValor allowNegative={false} moeda="real" decimalScale={2} fixedDecimalScale={false} placeholder="R$ 0,00"
                value={form[campo] ?? ''}
                onValueChange={({ floatValue }) => setForm(f => ({ ...f, [campo]: floatValue ?? null }))} />
        </FinField>
    );
    return (
        <>
            <div className="fin-pp__tabs mb-3">
                <button type="button" className={'fin-pp__tab' + (aba === 'comunicacao' ? ' is-active' : '')} onClick={() => naAba('comunicacao')}>
                    Comunicação Intermediária
                </button>
                <button type="button" className={'fin-pp__tab' + (aba === 'assentos' ? ' is-active' : '')} onClick={() => naAba('assentos')}>
                    Assentos
                </button>
                <button type="button" className={'fin-pp__tab' + (aba === 'reserva' ? ' is-active' : '')} onClick={() => naAba('reserva')}>
                    Reserva
                </button>
                <button type="button" className={'fin-pp__tab' + (aba === 'fee' ? ' is-active' : '')} onClick={() => naAba('fee')}>
                    FEE
                </button>
                <button type="button" className={'fin-pp__tab' + (aba === 'tempo' ? ' is-active' : '')} onClick={() => naAba('tempo')}>
                    Tempo de voo
                </button>
                <button type="button" className={'fin-pp__tab' + (aba === 'dblcheck' ? ' is-active' : '')} onClick={() => naAba('dblcheck')}>
                    DBL CHECK ({conferencias})
                </button>
            </div>
            {aba === 'comunicacao' && (
                <FinField label="Comunicação Intermediária" full>
                    <FinTextarea rows={4} autoFocus value={form.comunicacao ?? ''}
                        placeholder="Vai para a coluna COMUNICAÇÃO INTERMEDIADORA da planilha de emissão"
                        onChange={ev => { const texto = ev.target.value; setForm(f => ({ ...f, comunicacao: texto })); }} />
                </FinField>
            )}
            {aba === 'assentos' && (
                <div className="fin-pp__filters">
                    {assento('assentosIda', 'Assentos ida')}
                    {assento('assentosVolta', 'Assentos volta')}
                </div>
            )}
            {aba === 'reserva' && (reserva?.lados?.length ? (
                <>
                    <div className="fin-pp__cell-muted" style={{ fontSize: 12, marginBottom: 8 }}>
                        Valor prévio da reserva: entra no total e no TKT médio até o bilhete do lado chegar. A tarifa é a do bilhete, com o RAV/FEE quando houver.
                    </div>
                    <div className="fin-pp__filters">
                        {reserva.lados.map(lado => (
                            <React.Fragment key={lado}>
                                {valorPrevio(CAMPOS_PREVISTOS[lado][0], lado === 'ida' ? 'Tarifa ida' : 'Tarifa volta')}
                                {valorPrevio(CAMPOS_PREVISTOS[lado][1], lado === 'ida' ? 'Taxas ida' : 'Taxas volta')}
                            </React.Fragment>
                        ))}
                    </div>
                </>
            ) : (
                <div className="fin-pp__cell-muted">{reserva?.motivo}</div>
            ))}
            {aba === 'fee' && (
                <>
                    <div className="fin-pp__cell-muted" style={{ fontSize: 12, marginBottom: 8 }}>
                        {padrao !== null
                            ? `Padrão do cliente: ${brl(padrao)} por bilhete, ${feePadrao.origem === 'orcamento' ? 'do Fee Aéreo do orçamento do evento' : 'do catálogo do cliente'}.`
                            : 'Sem padrão: o evento não tem Fee Aéreo no orçamento, e o cliente não tem no catálogo.'}
                    </div>
                    <div className="fin-pp__filters">
                        <FinField label="FEE por bilhete">
                            <FinValor allowNegative={false} moeda="real" decimalScale={2} fixedDecimalScale={false}
                                placeholder={padrao !== null ? `${brl(padrao)} (Padrão)` : 'R$ 0,00'}
                                value={form.feeCliente ?? ''}
                                onValueChange={({ floatValue }) => setForm(f => ({ ...f, feeCliente: floatValue ?? null }))} />
                        </FinField>
                    </div>
                    <div className="fin-pp__cell-muted" style={{ fontSize: 12, margin: '4px 0 12px' }}>
                        {`Vazio usa o padrão. FEE desta linha: ${brl(feeDaLinha)}${numTkt ? ` (${numTkt} ${numTkt === 1 ? 'bilhete' : 'bilhetes'})` : ', sem bilhete contado'}.`}
                    </div>
                    <FinCheck checked={!!form.feeEmTodas} label="Aplicar este FEE por bilhete em todas as linhas que você opera"
                        onChange={ev => { const marcado = ev.target.checked; setForm(f => ({ ...f, feeEmTodas: marcado })); }} />
                </>
            )}
            {aba === 'tempo' && (
                <>
                    <div className="fin-pp__cell-muted" style={{ fontSize: 12, marginBottom: 8 }}>
                        Vai para as colunas TEMPO DE VOO da planilha. HH:MM, um por voo separados por | (01:05 | 02:10). O sistema não calcula: saída e chegada estão na hora local de cada aeroporto.
                    </div>
                    <div className="fin-pp__filters">
                        {tempoDeVoo('tempoVooIda', 'Tempo de voo ida')}
                        {tempoDeVoo('tempoVooRetorno', 'Tempo de voo volta')}
                    </div>
                </>
            )}
            {aba === 'dblcheck' && (
                <div className="d-flex flex-column gap-2">
                    {gravadas.map((c, n) => (
                        <div key={n} title="Conferência gravada: não se desmarca.">
                            <FinCheck checked disabled readOnly label={`${n + 1}ª conferência`} />
                            <div className="fin-pp__cell-muted" style={{ fontSize: 12, marginLeft: 26 }}>
                                {`Marcada em ${dataHora(c.em)}${c.nome ? ` por ${c.nome}` : ''}`}
                            </div>
                        </div>
                    ))}
                    <div>
                        <FinCheck checked={!!form.conferir} label={`${gravadas.length + 1}ª conferência`}
                            onChange={ev => { const marcada = ev.target.checked; setForm(f => ({ ...f, conferir: marcada })); }} />
                        <div className="fin-pp__cell-muted" style={{ fontSize: 12, marginLeft: 26 }}>
                            {form.conferir ? 'Ao salvar, grava a data do Salvar e o seu nome.' : 'Não conferida.'}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

/**
 * Emissão de Aéreo — só o Aéreo (e admin) abre. A mesma planilha da tela do RSVP, aqui
 * preenchida: o Aéreo sobe os PDFs dos bilhetes (o sistema guarda o original, lê os voos e os
 * valores, casa com o participante solicitado e mostra as divergências), escolhe o status de
 * cada participante (com o motivo quando não emite) e GRAVA os bilhetes — é a gravação que
 * escreve a emissão no participante e marca "Emitido". Status e motivo ficam em rascunho na tela
 * até o Salvar, que os guarda no rascunho do Aéreo, sem mandar: o RSVP não vê, e quem é do Aéreo vê
 * na linha (`aereoPendente`). O "Enviar para o RSVP" do rodapé passa para a linha o que a tela mudou e
 * o que estava salvo e grava os bilhetes prontos de uma vez, com o e-mail da emissão ao RSVP e, havendo
 * cancelamento, outro só com ele.
 *
 * SIGILO: o PDF original tem os valores faturados. A tela só baixa a cópia editada; o original
 * sai só para admin e Aéreo, depois da ciência na confirmação.
 *
 * ATENDIMENTO: o do evento, o mesmo das telas da malha (`useAtendimentoAereo`) — o Aéreo que não
 * atende o evento lê a tela, e o modal oferece assumir. E o de cada participante: as abas separam
 * Minhas emissões (as linhas que a pessoa opera), Todos, Sem atendente e uma por pessoa, só leitura.
 * Quem atende o evento marca e assume participantes em qualquer aba — o de outra pessoa passa por um
 * modal com quem atendia, que recebe um e-mail —, e em Minhas emissões o mesmo botão desvincula. O
 * Salvar e o Enviar levam só as linhas de quem está na tela; o admin opera todas e não assume. O back
 * confere tudo do mesmo jeito.
 */
export default function CadastroEventoEmissaoAereo({ match }) {
    const idEvento = match.params.idEvento;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({ liberada: false, participantes: [], bilhetesSoltos: [], legenda: {}, requisicoes: [] });
    const [header, setHeader] = useState({});
    const [carregando, setCarregando] = useState(true);
    const [processando, setProcessando] = useState(false);
    const [arquivos, setArquivos] = useState([]);
    const [selecionados, setSelecionados] = useState(new Set()); // bilhetes a gravar
    const [modal, setModal] = useState(null); // 'subir' | 'enviarRsvp' | {tipo:'original'|'vincular'|'excluir'|'status'|'assumir', ...}
    const [rascunhos, setRascunhos] = useState({}); // { [idEmissao]: { rotulo?, observacao?, reembolsoPrevisto? } } — o que a tela mudou e ainda não gravou
    const [baixando, setBaixando] = useState(null); // download em andamento: 'editada:<id>' | 'editadas' | 'planilha'
    const [ciente, setCiente] = useState(false);
    const [form, setForm] = useState({});
    const [busca, setBusca] = useState('');
    const [filtro, setFiltro] = useState(null);
    const [filtroRequisicao, setFiltroRequisicao] = useState(null);
    const [filtroOrigem, setFiltroOrigem] = useState(null);
    // O filtro por voo ({ cia, voo, data }) e se a linha dele está aberta: fechar a linha não tira o filtro.
    const [filtroVoo, setFiltroVoo] = useState(FILTRO_VOO_VAZIO);
    const [comFiltroVoo, setComFiltroVoo] = useState(false);
    // A aba da planilha, no rodapé da tabela (`AbasDaPlanilha`): o filtro dela ("ano|tipos", `chaveDaAba`), ou null
    // para a Todos Participantes. É pelo filtro, e não pelo id, que a aba nova continua escolhida depois do Salvar.
    const [abaPlanilha, setAbaPlanilha] = useState(null);
    // As abas que a tela mudou e ainda não gravou: as novas ({ id: 'nova-...', nome, ano, tipos }) e os ids das
    // salvas que saem. Vão no Salvar e no Enviar, com as linhas.
    const [abasRascunho, setAbasRascunho] = useState(ABAS_SEM_RASCUNHO);
    // A aba: 'minhas', 'todos', 'livres' ou 'pessoa:<id>'. Null até a pessoa escolher: a tela abre nas
    // dela quando tem alguma.
    const [aba, setAba] = useState(null);
    // O Consolidado aberto no lugar da planilha: o badge da barra de status abre e fecha; qualquer aba de
    // atendente, ou um filtro por status, volta à planilha.
    const [consolidado, setConsolidado] = useState(false);
    // Os participantes marcados para assumir ou desvincular.
    const [marcados, setMarcados] = useState(new Set());
    // Conta as recargas da emissão: a faixa de status confere o filtro em cada uma (`ChipsLegenda`).
    const [recargas, setRecargas] = useState(0);

    const carregar = useCallback(() => {
        setCarregando(true);
        api({ method: 'get', action: '/eventoAereoEmissao', token, params: { evento: idEvento } })
            .then(res => { setDados(res.data.data ?? { participantes: [], bilhetesSoltos: [] }); setRecargas(n => n + 1); })
            .catch(err => notify.apiError(err, 'Erro ao carregar a emissão'))
            .finally(() => setCarregando(false));
    }, [idEvento, token]);

    // Assumir o evento relê a emissão: é ela que diz quem atende cada participante.
    const atendimento = useAtendimentoAereo(idEvento, carregar);

    useEffect(() => {
        carregar();
        api({ method: 'get', action: '/eventoAereoCabecalho', token, params: { evento: idEvento } })
            .then(res => setHeader(res.data?.data ?? {}))
            .catch(() => {});
    }, [carregar, idEvento, token]);

    // Trilha fixa Evento → Emissão de Aéreo: o Aéreo chega pelo painel do evento ou pelo e-mail.
    const setFullTrail = useSetFullBreadcrumbTrail();
    useEffect(() => {
        if (!header.nomeEvento) return;
        setFullTrail([
            { path: `/evento?idEvento=${idEvento}`, label: header.nomeEvento },
            { path: `/cadastroEventoEmissaoAereo/${idEvento}`, label: 'Emissão de Aéreo' },
        ]);
    }, [header.nomeEvento, idEvento, setFullTrail]);

    const participantes = useMemo(() => dados.participantes ?? [], [dados.participantes]);
    const soltos = dados.bilhetesSoltos ?? [];

    // Quem opera cada linha: quem atende o participante; o admin, todas (`operaTudo`). O Aéreo sem o
    // atendimento do evento não opera nenhuma (`atendimento.opera`).
    const eu = dados.eu ?? null;
    const operaTudo = !!dados.operaTudo;
    const opera = (p) => operaTudo || (atendimento.opera && !!eu && p.atendente?.id === eu);
    // A badge da tela Aéreo que conta um só participante abre a emissão nele (`?participante=`): a busca com o nome
    // dele, na aba em que ele está — Minhas emissões, se é de quem está na tela.
    const location = useLocation();
    const focoDaUrl = useRef(new URLSearchParams(location.search).get('participante'));
    useEffect(() => {
        const p = focoDaUrl.current && participantes.find(x => x.id === focoDaUrl.current);
        if (!p) return;
        focoDaUrl.current = null;
        setAba(!operaTudo && !!eu && p.atendente?.id === eu ? 'minhas' : 'todos');
        setBusca(p.nome);
    }, [participantes, eu, operaTudo]);
    const minhas = participantes.filter(p => !!eu && p.atendente?.id === eu);
    const semAtendente = participantes.filter(p => !p.atendente);
    // Uma aba por pessoa que atende alguém, fora quem está na tela: a dela é Minhas emissões.
    const pessoas = useMemo(() => {
        const mapa = new Map();
        participantes.forEach(p => {
            if (!p.atendente || p.atendente.id === eu) return;
            const x = mapa.get(p.atendente.id) ?? { id: p.atendente.id, nome: p.atendente.nome ?? '—', n: 0 };
            x.n += 1;
            mapa.set(p.atendente.id, x);
        });
        return [...mapa.values()].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    }, [participantes, eu]);
    // A aba aberta: a escolhida, se ainda existe (a pessoa que perdeu todos sai das abas); senão, Minhas
    // emissões quando há alguma, ou Todos. O admin não atende: fica sem a aba dele.
    const abaExiste = aba === 'todos' || aba === 'livres' || (aba === 'minhas' && !operaTudo)
        || pessoas.some(x => 'pessoa:' + x.id === aba);
    const abaAtiva = abaExiste ? aba : (!operaTudo && minhas.length ? 'minhas' : 'todos');
    const linhasDe = (a) => (a === 'minhas' ? minhas
        : a === 'livres' ? semAtendente
            : a.startsWith('pessoa:') ? participantes.filter(p => p.atendente?.id === a.slice('pessoa:'.length))
                : participantes);
    const linhasDaAba = linhasDe(abaAtiva);
    // A linha se edita em Minhas emissões; nas outras abas, só se lê — menos para o admin, que opera todas.
    const podeEditarLinha = (p) => operaTudo || (abaAtiva === 'minhas' && opera(p));

    // Os filtros valem juntos e propagam entre si: cada um conta as opções dele com as linhas da aba que passam
    // nos OUTROS (`semOFiltro`), e as chips de status contam as que passam no painel. As opções continuam as da
    // aba, e a contagem pode dar 0.
    // `feePadrao`: o FEE por bilhete padrão do evento, que vale na linha cujo rascunho tirou o FEE dela.
    const tela = { aereo: true, rascunhos, feePadrao: dados.feePadrao?.valor ?? null };
    // As abas da planilha como a tela as mostra: as salvas, com a marca das que saem no Salvar, e as novas no fim.
    const abasNaTela = useMemo(() => [
        ...(dados.abas ?? []).map(a => ({ ...a, excluir: abasRascunho.excluidas.includes(a.id) })),
        ...abasRascunho.novas.map(a => ({ ...a, nova: true })),
    ], [dados.abas, abasRascunho]);
    // A escolhida, pelo filtro: a que fica antes da que sai com o mesmo. A que saiu no Salvar, ou que outra pessoa
    // excluiu, não volta na recarga, e a tela fica na Todos.
    const comAChave = (a) => chaveDaAba(a.ano, a.tipos) === abaPlanilha;
    const abaEscolhida = abaPlanilha === null ? null
        : abasNaTela.find(a => !a.excluir && comAChave(a)) ?? abasNaTela.find(comAChave) ?? null;
    const filtros = { status: filtro, busca, origem: filtroOrigem, requisicao: filtroRequisicao, voo: filtroVoo, aba: abaEscolhida };
    const semOFiltro = (chave) => linhasDaAba.filter(l => passaNosFiltros(l, filtros, tela, chave));
    const definir = {
        status: setFiltro, busca: setBusca, origem: setFiltroOrigem, requisicao: setFiltroRequisicao, voo: setFiltroVoo,
        aba: (a) => setAbaPlanilha(a ? chaveDaAba(a.ano, a.tipos) : null),
    };
    const semValor = { status: null, busca: '', origem: null, requisicao: null, voo: FILTRO_VOO_VAZIO, aba: null };
    // Escolher um filtro limpa os outros que ficaram sem nenhuma linha equivalente (`filtrosSemEquivalente`).
    const filtrar = (chave, valor) => {
        definir[chave](valor);
        filtrosSemEquivalente(linhasDaAba, { ...filtros, [chave]: valor }, chave, tela).forEach(outro => definir[outro](semValor[outro]));
    };
    // Trocar de aba de atendente é como escolher um filtro: os filtros ficam, e sai só o que ficou sem nenhuma
    // linha equivalente na aba nova, a aba da planilha inclusive.
    const trocarAba = (a) => {
        setAba(a); setMarcados(new Set()); setConsolidado(false);
        filtrosSemEquivalente(linhasDe(a), filtros, null, tela).forEach(outro => definir[outro](semValor[outro]));
    };
    // O X da aba da planilha: a nova sai da tela; a salva fica marcada para sair no Salvar, e o mesmo botão a mantém.
    const alternarAba = (a) => setAbasRascunho(r => (a.nova
        ? { ...r, novas: r.novas.filter(x => x.id !== a.id) }
        : { ...r, excluidas: r.excluidas.includes(a.id) ? r.excluidas.filter(id => id !== a.id) : [...r.excluidas, a.id] }));
    // O Aplicar da aba nova: entra no rascunho da tela, e ela já abre nessa aba.
    const aplicarAba = (nova) => {
        setAbasRascunho(r => ({ ...r, novas: [...r.novas, { ...nova, id: `nova-${Date.now()}` }] }));
        filtrar('aba', nova);
        setModal(null);
    };
    // O nome da Todos Participantes (`ehDaTodos`): o novo entra no rascunho no lugar do que ela tinha, e grava no Salvar.
    const nomearTodos = ({ nome }) => {
        setAbasRascunho(r => ({
            novas: [...r.novas.filter(a => !ehDaTodos(a)), { nome, ano: null, tipos: [], id: `nova-${Date.now()}` }],
            excluidas: [...r.excluidas, ...(dados.abas ?? []).filter(a => ehDaTodos(a) && !r.excluidas.includes(a.id)).map(a => a.id)],
        }));
        setModal(null);
    };
    // O rascunho das abas como o Salvar e o Enviar o mandam.
    const abasParaSalvar = { novas: abasRascunho.novas.map(({ nome, ano, tipos }) => ({ nome, ano, tipos })), excluidas: abasRascunho.excluidas };
    const abasAlteradas = abasRascunho.novas.length + abasRascunho.excluidas.length;

    // Marcar para assumir ou desvincular: quem atende o evento, em qualquer aba. O admin opera todas as
    // linhas sem atender, e não assume.
    const podeAssumir = !operaTudo && atendimento.opera;
    const selecaoAtendimento = podeAssumir ? {
        marcados,
        selecionavel: () => true,
        alternar: (id) => setMarcados(prev => {
            const novo = new Set(prev);
            if (novo.has(id)) novo.delete(id); else novo.add(id);
            return novo;
        }),
        marcarVarios: (ids, marcado) => setMarcados(prev => {
            const novo = new Set(prev);
            ids.forEach(id => { if (marcado) novo.add(id); else novo.delete(id); });
            return novo;
        }),
    } : null;
    const marcadosNaAba = selecaoAtendimento ? linhasDaAba.filter(p => marcados.has(p.id) && selecaoAtendimento.selecionavel(p)) : [];
    // Em Minhas emissões, ou com só as suas marcadas, o botão desvincula; senão, assume as marcadas que
    // não são de quem está na tela.
    const marcadosDeOutros = marcadosNaAba.filter(p => p.atendente?.id !== eu);
    const desvincula = abaAtiva === 'minhas' || (marcadosNaAba.length > 0 && !marcadosDeOutros.length);
    // As que estão com outra pessoa passam pelo modal, com quem atendia: { id, nome, n } por pessoa.
    const mapaQuemAtendia = new Map();
    marcadosDeOutros.forEach(p => {
        if (!p.atendente) return;
        const x = mapaQuemAtendia.get(p.atendente.id) ?? { id: p.atendente.id, nome: p.atendente.nome ?? '—', n: 0 };
        x.n += 1;
        mapaQuemAtendia.set(p.atendente.id, x);
    });
    const quemAtendia = [...mapaQuemAtendia.values()].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    const deOutraPessoa = quemAtendia.reduce((t, x) => t + x.n, 0);
    // Subir, vincular e excluir bilhete são do evento, de quem o atende: o bilhete casa com o participante
    // sozinho, e quem o grava é quem atende a linha. Salvar e Enviar também só aparecem para quem opera.
    const podeSubir = !!dados.podeSubir && atendimento.opera;
    // Todos os bilhetes com participante, para a revisão da gravação: os de cada linha do participante,
    // as anteriores e a atual, cada uma com os dela.
    const bilhetesDasLinhas = useMemo(() => participantes.flatMap(p => entradasDe(p)
        .flatMap(x => (x.bilhetes ?? []).map(b => ({
            ...b,
            participante: { id: p.id, nome: p.nome, ladosEmitidos: p.emissao?.ladosEmitidos ?? {}, atendente: p.atendente ?? null },
            // É a PRÓPRIA linha, como a tela a deixou, que diz se o bilhete grava (`prontoParaGravar`): a
            // cancelada só grava marcada como Emitido no rascunho. Com a da atual, o bilhete de uma anterior
            // já cancelada contava como pronto, e o back recusava o envio inteiro.
            cancelada: canceladaNaTela(x, rascunhos),
        })))), [participantes, rascunhos]);
    // Não há seleção de bilhete: todo bilhete pronto vai no próximo envio. O Aéreo não escolhe o que
    // mandar — ele exclui o que não presta e grava o resto. A regra de "pronto" é a mesma da planilha.
    // Só os das linhas que quem está na tela opera: os outros esperam o Enviar de quem atende o participante.
    const gravavel = (b) => prontoParaGravar(b, b.cancelada) && opera(b.participante);
    const prontosParaGravar = bilhetesDasLinhas.filter(gravavel);
    // Os que estariam prontos, mas são da linha com o voo trocado depois da requisição: ficam fora do Enviar
    // até o RSVP pedir de novo, e o modal e o toast dizem de quem.
    const retidos = bilhetesDasLinhas.filter(b => retidoPeloVooTrocado(b, b.cancelada) && opera(b.participante));
    const nomesRetidos = [...new Set(retidos.map(b => b.participante?.nome ?? '—'))];
    // A revisão de um participante, pelo clique no bilhete: os bilhetes dele que o Enviar grava e o clicado, mesmo
    // que não vá no envio (o já emitido, por exemplo).
    const donoDaRevisao = modal?.tipo === 'revisao' ? bilhetesDasLinhas.find(x => x.id === modal.bilhete.id)?.participante ?? null : null;
    const bilhetesDaRevisao = donoDaRevisao
        ? bilhetesDasLinhas.filter(x => x.participante.id === donoDaRevisao.id && (gravavel(x) || x.id === modal.bilhete.id)) : [];

    const post = (action, data, sucesso, depois = null) => {
        setProcessando(true);
        return api({ method: 'post', action, token, data })
            .then(res => {
                if (res.data?.status === false) throw { response: res };
                if (sucesso) toast.success(sucesso);
                setModal(null);
                if (depois) depois(res);
                carregar();
            })
            .catch(err => notify.apiError(err, 'Não foi possível concluir'))
            .finally(() => setProcessando(false));
    };

    // Assume as marcadas que não são de quem está na tela; quem atendia alguma recebe um e-mail.
    const assumir = () => post('/eventoAereoEmissaoAssumir', { evento: idEvento, participantes: marcadosDeOutros.map(p => p.id) },
        marcadosDeOutros.length > 1 ? `Você assumiu ${marcadosDeOutros.length} participantes` : 'Você assumiu o participante',
        () => setMarcados(new Set()));
    // Com alguma de outra pessoa, o modal confirma antes; as sem atendente vão direto.
    const pedirAssumir = () => (deOutraPessoa ? setModal({ tipo: 'assumir' }) : assumir());
    // Deixa as suas marcadas sem atendente. Sem e-mail. A linha com alteração que ainda não foi ao RSVP
    // (`linhasPendentes`, as do próximo Enviar) fica com quem a fez até o Enviar: o rascunho dela sairia
    // da tela, e o resto esperaria outra pessoa. O back confere o que está gravado.
    const desvincular = () => {
        const comAlteracao = marcadosNaAba.filter(p => entradasDe(p).some(e => linhasPendentes.has(String(e.id))));
        if (comAlteracao.length) {
            const nomes = comAlteracao.length > 3 ? `${comAlteracao.length} participantes`
                : comAlteracao.length > 1
                    ? `${comAlteracao.slice(0, -1).map(p => p.nome).join(', ')} e ${comAlteracao[comAlteracao.length - 1].nome}`
                    : comAlteracao[0].nome;
            toast.error(`Não foi possível desvincular: ${nomes} ${comAlteracao.length > 1 ? 'têm' : 'tem'} alteração na linha que ainda não foi enviada ao RSVP. Envie antes de desvincular.`);
            return;
        }
        post('/eventoAereoEmissaoDesvincular', { evento: idEvento, participantes: marcadosNaAba.map(p => p.id) },
            marcadosNaAba.length > 1 ? `${marcadosNaAba.length} participantes sem atendente` : 'Participante sem atendente',
            () => setMarcados(new Set()));
    };

    // O rascunho da linha: nada vai ao banco até o Salvar ou o "Enviar para o RSVP".
    const rascunhar = (idEmissao, campos) => setRascunhos(prev => ({ ...prev, [idEmissao]: { ...(prev[idEmissao] ?? {}), ...campos } }));
    // O X da anotação não enviada marca (ou desmarca) a exclusão no rascunho da tela, que vai no Salvar ou no
    // Enviar com o resto (`excluirObservacoes`). Nada vai ao back antes.
    const alternarExclusao = (idEmissao, nota) => setRascunhos(prev => {
        const { excluirObservacoes = [], ...resto } = prev[idEmissao] ?? {};
        const mesma = (x) => x.indice === nota.indice && x.texto === nota.texto;
        const marcadas = excluirObservacoes.some(mesma)
            ? excluirObservacoes.filter(x => !mesma(x))
            : [...excluirObservacoes, { indice: nota.indice, texto: nota.texto }];
        const linha = marcadas.length ? { ...resto, excluirObservacoes: marcadas } : resto;
        const novo = { ...prev, [idEmissao]: linha };
        if (!Object.keys(linha).length) delete novo[idEmissao];
        return novo;
    });
    // O Aplicar do lápis: as colunas editáveis vão para o rascunho da linha, como o status. A comunicação
    // e os assentos iguais aos da linha e sem conferência nova não ficam no rascunho.
    const rascunharColunas = (linha, f) => {
        const id = linha.emissao.id;
        const texto = String(f.comunicacao ?? '').trim();
        const mudouTexto = texto !== String(linha.emissao.comunicacaoIntermediaria ?? '').trim();
        const assentos = Object.fromEntries(['assentosIda', 'assentosVolta']
            .filter(campo => (f[campo] ?? null) !== (linha.emissao[campo] ?? null))
            .map(campo => [campo, f[campo] ?? null]));
        // O tempo de voo, como os assentos: o igual ao da linha (sem espaço de sobra) não fica no rascunho; vazio limpa.
        const tempos = Object.fromEntries(['tempoVooIda', 'tempoVooRetorno']
            .map(campo => [campo, String(f[campo] ?? '').trim()])
            .filter(([campo, texto]) => texto.replace(/\s+/g, '') !== String(linha.emissao[campo] ?? '').replace(/\s+/g, ''))
            .map(([campo, texto]) => [campo, texto === '' ? null : texto]));
        // A reserva dos lados que a aba edita (`reservaDoLapis`), como os assentos: a igual à da linha sai do rascunho.
        const camposReserva = reservaDoLapis(linha).lados.flatMap(lado => CAMPOS_PREVISTOS[lado]);
        const reserva = Object.fromEntries(camposReserva
            .filter(campo => (f[campo] ?? null) !== (linha.emissao[campo] ?? null))
            .map(campo => [campo, f[campo] ?? null]));
        setRascunhos(prev => {
            const { comunicacaoIntermediaria, conferir, assentosIda, assentosVolta, tempoVooIda, tempoVooRetorno, ...semColunas } = prev[id] ?? {};
            const resto = Object.fromEntries(Object.entries(semColunas).filter(([campo]) => !camposReserva.includes(campo)));
            const campos = {
                ...resto,
                ...(mudouTexto ? { comunicacaoIntermediaria: texto } : {}),
                ...assentos,
                ...tempos,
                ...reserva,
                ...(f.conferir ? { conferir: true } : {}),
            };
            const next = { ...prev };
            if (Object.keys(campos).length) next[id] = campos;
            else delete next[id];
            return next;
        });
        // O FEE por bilhete (aba FEE): nesta linha, ou em todas as que quem está na tela opera (`feeEmTodas`). O igual
        // ao da linha sai do rascunho dela, como os assentos.
        const feeNovo = f.feeCliente ?? null;
        const alvosDoFee = f.feeEmTodas ? participantes.filter(opera).flatMap(entradasDe) : [linha.emissao];
        setRascunhos(prev => {
            const next = { ...prev };
            alvosDoFee.forEach(x => {
                const { feeCliente, ...resto } = next[x.id] ?? {};
                const campos = feeNovo !== (x.feeCliente ?? null) ? { ...resto, feeCliente: feeNovo } : resto;
                if (Object.keys(campos).length) next[x.id] = campos;
                else delete next[x.id];
            });
            return next;
        });
    };
    // O Aplicar do DBL CHK em massa: a conferência de cada linha da lista entra no rascunho dela, ou sai, como
    // o lápis faz numa linha só. `marcadas`: { [idEmissao]: boolean }.
    const rascunharConferencias = (marcadas) => setRascunhos(prev => {
        const next = { ...prev };
        Object.entries(marcadas).forEach(([id, marcada]) => {
            const { conferir, ...resto } = next[id] ?? {};
            const campos = marcada ? { ...resto, conferir: true } : resto;
            if (Object.keys(campos).length) next[id] = campos;
            else delete next[id];
        });
        return next;
    });
    // As entradas que quem está na tela opera. O rascunho de linha que deixou de ser dela — outra pessoa
    // assumiu o participante, ou ela deixou de atender o evento — não vai no Salvar
    // nem no Enviar, porque o back recusaria o envio inteiro, e sai da tela.
    const entradasMinhas = new Set(participantes.filter(opera).flatMap(entradasDe).map(e => String(e.id)));
    const chaveEntradasMinhas = [...entradasMinhas].sort().join(',');
    useEffect(() => {
        setRascunhos(prev => {
            const fora = Object.keys(prev).filter(id => !entradasMinhas.has(String(id)));
            if (!fora.length) return prev;
            const next = { ...prev };
            fora.forEach(id => { delete next[id]; });
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chaveEntradasMinhas]);
    const linhasParaEnviar = Object.entries(rascunhos).filter(([emissao]) => entradasMinhas.has(String(emissao)))
        .map(([emissao, campos]) => ({ emissao, ...campos }));
    // As linhas com rascunho salvo que ainda não foi ao RSVP (`aereoPendente`): ele só as vê no Enviar. Só
    // as de quem está na tela: o Enviar é de cada um.
    const salvasSemEnviar = participantes.filter(opera).flatMap(entradasDe).filter(e => e.aereoPendente);

    // Tira o status do rascunho da linha e deixa o resto (a observação): volta a valer o automático,
    // que é o Emitido quando os bilhetes que vão ser gravados fecham a emissão — também por cima do
    // status salvo antes, que a gravação troca.
    const semStatusNoRascunho = (idEmissao) => setRascunhos(prev => {
        if (!prev[idEmissao]) return prev;
        // A reserva prevista sai com o status, como o reembolso: só existe com ele.
        const { rotulo, motivo, reembolsoPrevisto, tarifaPrevistaIda, taxasPrevistasIda, tarifaPrevistaRetorno, taxasPrevistasRetorno,
            ...resto } = prev[idEmissao];
        const next = { ...prev };
        if (Object.keys(resto).length) next[idEmissao] = resto;
        else delete next[idEmissao];
        return next;
    });

    // Status escolhido na linha: sem observação obrigatória vai direto para o rascunho; com, abre o motivo.
    // O Emitido que a gravação já ia dar (`emitidoAutomatico`) é desfazer o status escolhido antes; na
    // linha que só tem bilhete — a cancelada também —, ele vai para o rascunho, e o Enviar grava o bilhete.
    const escolherStatus = (linha, rotulo, { emitidoAutomatico = false } = {}) => {
        if (rotulo === 'EMITIDO') {
            if (emitidoAutomatico) semStatusNoRascunho(linha.emissao.id);
            else rascunhar(linha.emissao.id, { rotulo });
            return;
        }
        if (ROTULOS_SEM_OBSERVACAO.includes(rotulo)) {
            rascunhar(linha.emissao.id, { rotulo });
            return;
        }
        // O motivo é uma anotação nova: abre em branco, ou com a que ainda está no rascunho da tela. A
        // gravada não se edita. A reserva prevista abre com a da tela ou a da linha.
        const r = rascunhos[linha.emissao.id] ?? {};
        setForm({
            observacao: r.observacao ?? '',
            ...Object.fromEntries(Object.values(CAMPOS_PREVISTOS).flat().map(c => [c, c in r ? r[c] : (linha.emissao[c] ?? null)])),
        });
        setModal({ tipo: 'status', linha, rotulo });
    };
    // Os lados da reserva que o motivo pede: os que o status põe em aprovação de custos, que a linha usa (a anterior
    // diz o que ela pediu; a atual, o participante) e que ainda não têm bilhete na linha (com bilhete, vale o dele).
    const ladosDaReserva = (linha, rotulo) => ladosEmCustos(rotulo)
        .filter(lado => {
            const campo = lado === 'ida' ? 'naoUtilizaIda' : 'naoUtilizaRetorno';
            return !(linha.emissao?.[campo] ?? linha[campo]);
        })
        .filter(lado => !linha.emissao?.valores?.ladosComBilhete?.[lado]);
    // A aba Reserva do lápis: os mesmos lados do motivo, pelo status que a tela mostra (o do rascunho, ou o da linha);
    // sem nenhum, o porquê.
    const reservaDoLapis = (linha) => {
        const r = rascunhos[linha.emissao.id];
        const rotulo = r && r.rotulo ? r.rotulo : (linha.emissao.rotulo?.[0] ?? '');
        return {
            lados: ladosDaReserva(linha, rotulo),
            motivo: ladosEmCustos(rotulo).length
                ? 'O lado em aprovação de custos já tem bilhete, ou o participante não o usa: vale o valor do bilhete.'
                : 'O valor prévio só existe com PENDENTE APROVAÇÃO CUSTOS em algum lado. Escolha esse status para informá-lo.',
        };
    };
    // Um envio só: os rascunhos, as linhas novas salvas e todos os bilhetes prontos. O cancelamento vai
    // ao RSVP em e-mail próprio.
    // Linhas (entradas), não participantes nem ações: a linha que leva status e bilhete no mesmo envio
    // conta uma vez só; a anterior e a atual do mesmo participante contam cada uma. Conta toda alteração, da
    // tela ou salva: o rascunho salvo não diz se é status ou só as colunas do lápis.
    const linhasAlteradas = new Set([...linhasParaEnviar.map(l => String(l.emissao)), ...salvasSemEnviar.map(e => String(e.id))]).size;
    // As linhas do próximo Enviar: com rascunho, novas salvas ou com bilhete pronto. Também travam o desvincular.
    const linhasPendentes = new Set([...linhasParaEnviar.map(l => String(l.emissao)), ...salvasSemEnviar.map(e => String(e.id)), ...prontosParaGravar.map(b => String(b.emissao))]);
    const aEnviar = linhasPendentes.size;
    // A sugestão de voos salva que o RSVP ainda não recebeu: vai junto no Enviar, e sozinha também habilita.
    const sugestaoAEnviar = !!dados.sugestao?.aEnviar;
    const enviarParaRsvp = () => post('/eventoAereoEmissaoLinhas', { evento: idEvento, linhas: linhasParaEnviar, bilhetes: prontosParaGravar.map(b => b.id), abas: abasParaSalvar },
        'Enviado ao RSVP', (res) => {
            setRascunhos({});
            setAbasRascunho(ABAS_SEM_RASCUNHO);
            // Quem ficou com o bilhete fora: o que a tela já sabia e o que o back segurou (`retidos`), a troca
            // de voo feita com a tela aberta.
            const nomes = [...new Set([...nomesRetidos, ...(res?.data?.data?.retidos ?? [])])];
            if (nomes.length) toast.warning(`Não enviado: o bilhete de ${nomes.join(', ')}. O convidado trocou o voo depois da requisição, e o bilhete espera o RSVP reenviar a linha.`);
        });
    // Guarda os rascunhos da tela no rascunho do Aéreo, sem e-mail: o RSVP só vê no Enviar. As abas da planilha
    // gravam aqui, e o RSVP já as vê.
    const salvar = () => {
        setProcessando(true);
        return api({ method: 'post', action: '/eventoAereoEmissaoLinhasSalvar', token, data: { evento: idEvento, linhas: linhasParaEnviar, abas: abasParaSalvar } })
            .then(res => {
                if (res.data?.status === false) throw { response: res };
                toast.success(linhasParaEnviar.length ? 'Salvo, sem mandar ao RSVP: ele vê no Enviar para o RSVP.' : 'Abas da planilha salvas.');
                setRascunhos({});
                setAbasRascunho(ABAS_SEM_RASCUNHO);
                carregar();
                return true;
            })
            .catch(err => { notify.apiError(err, 'Não foi possível salvar'); return false; })
            .finally(() => setProcessando(false));
    };
    // A planilha é a da tela: com rascunho, o Salvar grava antes, sem mandar ao RSVP, e ela sai com o
    // rascunho do Aéreo. A linha que o Enviar vai emitir já sai Emitido (o back conta os bilhetes prontos),
    // mas o bilhete só grava no Enviar. Os filtros da tela não filtram o arquivo, que é do evento inteiro.
    const baixarPlanilha = async () => {
        if ((linhasParaEnviar.length || abasAlteradas) && !(await salvar())) return;
        baixar('planilha', `${API}/eventoAereoEmissaoPlanilha?evento=${idEvento}`, 'Emissao-Aereo.xlsx');
    };

    // Cada escolha no dropzone soma à lista local; nada sobe antes do botão Subir. Fica de fora o
    // que não é PDF (arrastar não respeita o `accept`), o que passa de 10 MB (o back recusaria o
    // lote inteiro) e o arquivo que já está na lista.
    const adicionarArquivos = (lista) => {
        const pdfs = lista.filter(f => f.type === 'application/pdf' || /\.pdf$/i.test(f.name));
        const foraDoFormato = lista.length - pdfs.length;
        if (foraDoFormato) toast.warning(foraDoFormato === 1 ? 'Só PDF: 1 arquivo ficou de fora.' : `Só PDF: ${foraDoFormato} arquivos ficaram de fora.`);
        pdfs.filter(f => f.size > LIMITE_PDF).forEach(f => toast.warning(`${f.name}: passa de 10 MB.`));
        const cabem = pdfs.filter(f => f.size <= LIMITE_PDF);
        const novos = [];
        cabem.forEach(f => { if (![...arquivos, ...novos].some(a => chaveArquivo(a) === chaveArquivo(f))) novos.push(f); });
        if (novos.length < cabem.length) toast.info('Arquivo já está na lista.');
        if (novos.length) setArquivos([...arquivos, ...novos]);
    };
    const removerArquivo = (chave) => setArquivos(arquivos.filter(f => chaveArquivo(f) !== chave));

    const subir = async () => {
        setProcessando(true);
        try {
            const fd = new FormData();
            fd.append('evento', idEvento);
            arquivos.forEach(f => fd.append('arquivos[]', f));
            const res = await axios.post(`${API}/eventoAereoEmissaoBilhetes`, fd, { headers: { Authorization: `Bearer ${token}` } });
            const lista = res.data?.data?.bilhetes ?? [];
            const lidos = lista.filter(b => b.id && b.situacao !== 'nao_lido');
            const naoLidos = lista.filter(b => b.situacao === 'nao_lido');
            toast.success(`${lidos.length} de ${lista.length} bilhete${lista.length !== 1 ? 's' : ''} lido${lidos.length !== 1 ? 's' : ''}`);
            naoLidos.forEach(b => toast.warning(`${b.arquivo}: ${b.motivo}`));
            setModal(null);
            setArquivos([]);
            carregar();
            // Depois do upload, a cópia editada de cada bilhete lido é baixada (aviso na confirmação).
            // A cópia é gerada na hora do download; a lista não espera por ela.
            if (lidos.length) {
                toast.info(lidos.length === 1 ? 'Gerando a cópia editada...' : 'Gerando as cópias editadas...', { toastId: 'copiasEditadas', autoClose: false });
                baixar('editadas', `${API}/eventoAereoEmissaoBilheteEditado?bilhetes=${lidos.map(b => b.id).join(',')}`,
                    lidos.length === 1 ? 'bilhete-editado.pdf' : 'bilhetes-editados.zip')
                    .finally(() => toast.dismiss('copiasEditadas'));
            }
        } catch (err) {
            notify.apiError(err, 'Erro ao subir os bilhetes');
        } finally {
            setProcessando(false);
        }
    };

    // Download com o botão em loading: a cópia editada e a planilha são geradas na hora. `corpo`: POST.
    const baixar = async (chave, url, nomePadrao, corpo = null) => {
        setBaixando(chave);
        try {
            return await baixarBlob(url, token, nomePadrao, corpo);
        } finally {
            setBaixando(null);
        }
    };

    const baixarOriginal = async () => {
        setProcessando(true);
        await baixarBlob(`${API}/eventoAereoEmissaoBilheteOriginal?bilhete=${modal.bilhete.id}`, token, 'bilhete-original.pdf');
        setProcessando(false);
        setModal(null);
        setCiente(false);
    };

    const resumoVoos = (d) => (d?.segmentos ?? []).map((s, i) => (
        <div key={i} style={{ whiteSpace: 'nowrap' }}>
            <strong>{s.cia} {s.voo}</strong> {s.origem?.codigo} → {s.destino?.codigo}
            <span className="fin-pp__cell-muted"> · {s.saida?.data} {s.saida?.hora}{s.chegada?.hora ? `–${s.chegada.hora}` : ''}</span>
        </div>
    ));

    const comDivergencia = bilhetesDasLinhas.filter(b => b.atual && (b.divergencias ?? []).length > 0).length;
    const semBilhete = participantes.filter(p => p.emissao && !p.emissao.temBilhete && p.emissao.situacao !== 'cancelado').length;
    const gravados = bilhetesDasLinhas.filter(b => b.situacao === 'gravado').length;
    // O bilhete sem participante que casou no upload com uma linha cancelada (`emissaoSugerida`) abre o modal no
    // participante dela, na linha atual dele, com o trecho achado: é o Vincular Cancelado.
    const linhaSugerida = (b) => participantes.find(p => p.emissao?.id === b.emissaoSugerida
        || (p.anteriores ?? []).some(x => x.id === b.emissaoSugerida))?.emissao?.id ?? '';
    const abreVinculo = (b) => {
        setForm({ emissao: b.emissao ?? (b.emissaoSugerida ? linhaSugerida(b) : ''), trecho: b.trecho ?? '', novaLinha: null });
        setModal({ tipo: 'vincular', bilhete: b });
    };
    // O Vincular Cancelado: a linha atual escolhida no modal está cancelada, e o Aéreo diz se o bilhete vai numa linha
    // nova, que o Enviar para o RSVP abre, ou na mesma.
    const vinculoCancelado = modal?.tipo === 'vincular'
        && participantes.some(p => p.emissao?.id === form.emissao && p.emissao.situacao === 'cancelado');

    return (
        <ErpTemplate processando={carregando}>
            <div className="main-content container-fluid fin-pp">
                <CabecalhoEventoAereo
                    titulo="Emissão de Aéreo"
                    nomeEvento={header.nomeEvento}
                    cliente={header.cliente}
                    solicitante={header.solicitante}
                    dataEvento={header.dataEvento}
                    localEvento={header.localEvento}
                    atalhos={[
                        atendimento.atalho,
                        { rotulo: 'Opções de Aéreo', titulo: 'Opções de aéreo do evento.', to: '/cadastroEventoRsvpOpcaoAereo/' + idEvento },
                        { rotulo: 'Sugestão de Voos', titulo: 'Voos sugeridos ao RSVP: vão no Enviar para o RSVP.', to: '/cadastroEventoSugestaoAereo/' + idEvento },
                    ]}
                    indicadores={[
                        { rotulo: 'Participantes na emissão', valor: participantes.length, tom: 'info' },
                        { rotulo: 'Requisições', valor: (dados.requisicoes ?? []).length, titulo: 'Cada Solicitar do RSVP é uma requisição numerada.' },
                        { rotulo: 'Bilhetes', valor: bilhetesDasLinhas.filter(b => b.situacao !== 'nao_lido').length + soltos.filter(b => b.situacao !== 'nao_lido').length },
                        { rotulo: 'Gravados', valor: gravados, tom: 'ok' },
                        { rotulo: 'Com divergência', valor: comDivergencia, tom: comDivergencia ? 'warn' : undefined },
                        { rotulo: 'Sem bilhete', valor: semBilhete, tom: semBilhete ? 'warn' : undefined },
                    ]}
                    // O que a reserva pede do evento, para copiar sem abrir a planilha: o da malha mais
                    // recente e, vazio, o do cadastro do evento (a mesma regra da planilha de emissão).
                    painel={[
                        { rotulo: 'Centro de Custo', valor: header.centroCusto, icone: <FaBuilding size={11} /> },
                        { rotulo: 'Ordem Interna (WBS)', valor: header.ordemInterna, icone: <FaHashtag size={11} /> },
                    ]}
                />

                {!carregando && !dados.liberada && (
                    <div className="fin-pp__card fin-pp__empty mb-3">
                        <FaLock size={14} style={{ marginRight: 8 }} />
                        A emissão abre depois que o RSVP solicita a emissão dos participantes na tela Solicitar Emissão de Aéreo.
                    </div>
                )}

                {/* Mesmo dropzone da importação da malha. Cada escolha entra na lista abaixo; o
                    botão Subir abre a confirmação, que avisa do download da cópia editada. */}
                {dados.liberada && podeSubir && (
                    <div className="fin-pp__card mb-3" style={{ padding: 16 }}>
                        <UploadDropzone onChange={adicionarArquivos} multiple centerOnDrag
                            accept="application/pdf,.pdf"
                            title="Arraste os PDFs dos bilhetes ou clique para adicionar"
                            disabled={processando} />
                    </div>
                )}

                {dados.liberada && podeSubir && arquivos.length > 0 && (
                    <div className="fin-pp__card mb-3" style={{ overflow: 'hidden' }}>
                        <div className="fin-pp__tblwrap">
                            <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                                <thead>
                                    <tr><th>Bilhetes a subir</th><th>Tamanho</th><th style={{ width: 1 }}></th></tr>
                                </thead>
                                <tbody>
                                    {arquivos.map(f => (
                                        <tr key={chaveArquivo(f)}>
                                            <td className="fin-pp__cell-strong"><FaFilePdf size={12} style={{ marginRight: 6 }} />{f.name}</td>
                                            <td className="fin-pp__cell-muted" style={{ whiteSpace: 'nowrap' }}>{tamanhoArquivo(f.size)}</td>
                                            <td>
                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" title="Tirar da lista"
                                                    disabled={processando} onClick={() => removerArquivo(chaveArquivo(f))}>
                                                    <FaTrash size={11} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="fin-pp__pagination">
                            <div className="fin-pp__pagination-info">
                                {arquivos.length} bilhete{arquivos.length !== 1 ? 's' : ''} · {tamanhoArquivo(arquivos.reduce((t, f) => t + f.size, 0))}
                            </div>
                            <div className="fin-pp__pagination-ctrls">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={processando} onClick={() => setArquivos([])}>
                                    Limpar lista
                                </button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" disabled={processando} onClick={() => setModal('subir')}>
                                    <FaUpload size={11} style={{ marginRight: 5 }} />
                                    Subir {arquivos.length} bilhete{arquivos.length !== 1 ? 's' : ''}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Bilhetes sem participante: não lidos, ou lidos sem casar. Vincula ou exclui. */}
                {dados.liberada && soltos.length > 0 && (
                    <div className="fin-pp__card mb-3" style={{ overflow: 'hidden' }}>
                        <div className="fin-pp__tblwrap">
                            <table className="fin-pp__tbl" style={{ minWidth: 900, tableLayout: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th>Bilhete sem participante</th><th>Voos</th><th>Motivo</th>
                                        <th style={{ width: 1 }}>
                                            {/* O "Excluir todos" à direita do título, na largura dos botões da linha. */}
                                            <div className="d-flex align-items-center justify-content-between gap-2" style={{ whiteSpace: 'nowrap' }}>
                                                <span>Ações</span>
                                                {podeSubir && (
                                                    <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                                        title="Excluir todos os bilhetes sem participante" disabled={processando}
                                                        onClick={() => setModal({ tipo: 'excluirTodos' })}>
                                                        <FaTrash size={11} /> Excluir todos
                                                    </button>
                                                )}
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {soltos.map(b => {
                                        const d = b.dados ?? {};
                                        return (
                                            <tr key={b.id}>
                                                <td>
                                                    <div className="fin-pp__cell-strong">{d.passageiro || d.arquivo || '—'}</div>
                                                    <div className="fin-pp__cell-muted">
                                                        {d.eticket ? `E-ticket ${eticketFormatado(d.eticket)}` : 'Sem número do bilhete'}{d.localizador ? ` · LOC ${d.localizador}` : ''}
                                                    </div>
                                                    {d.arquivo && d.passageiro && <div className="fin-pp__cell-muted" style={{ fontSize: 11 }}>{d.arquivo}</div>}
                                                </td>
                                                <td>{resumoVoos(d)}</td>
                                                <td>
                                                    <span className={'fin-pp__pill ' + (b.situacao === 'nao_lido' || b.emissaoSugerida ? 'is-danger' : 'is-warn')}>
                                                        {b.situacao === 'nao_lido' ? 'Não lido' : b.emissaoSugerida ? 'Linha cancelada' : 'Sem participante'}
                                                    </span>
                                                    {b.motivo && <div className="fin-pp__cell-muted" style={{ marginTop: 4 }}>{b.motivo}</div>}
                                                </td>
                                                <td>
                                                    <div className="d-flex gap-2" style={{ whiteSpace: 'nowrap' }}>
                                                        {podeSubir && b.situacao !== 'nao_lido' && (
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={processando} onClick={() => abreVinculo(b)}>
                                                                <FaLink size={10} style={{ marginRight: 4 }} /> {b.emissaoSugerida ? 'Vincular Cancelado' : 'Vincular'}
                                                            </button>
                                                        )}
                                                        {dados.podeOriginal && (
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" title="Versão original, com dados sigilosos"
                                                                onClick={() => { setCiente(false); setModal({ tipo: 'original', bilhete: b }); }}>
                                                                <FaLock size={10} style={{ marginRight: 4 }} /> Original
                                                            </button>
                                                        )}
                                                        {podeSubir && (
                                                            <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost" title="Excluir bilhete"
                                                                disabled={processando} onClick={() => setModal({ tipo: 'excluir', bilhete: b })}>
                                                                <FaTrash size={11} />
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* As abas do atendimento: as linhas de quem está na tela, todas, as sem ninguém e as de cada
                    pessoa. Filtros, status e seleção valem dentro da aba; os totais são do evento inteiro. */}
                {dados.liberada && (
                    <div className="fin-pp__tabs mb-3">
                        {!operaTudo && (
                            <button type="button" className={'fin-pp__tab' + (abaAtiva === 'minhas' ? ' is-active' : '')} onClick={() => trocarAba('minhas')}>
                                Minhas emissões ({minhas.length})
                            </button>
                        )}
                        <button type="button" className={'fin-pp__tab' + (abaAtiva === 'todos' ? ' is-active' : '')} onClick={() => trocarAba('todos')}>
                            Todos ({participantes.length})
                        </button>
                        <button type="button" className={'fin-pp__tab' + (abaAtiva === 'livres' ? ' is-active' : '')} onClick={() => trocarAba('livres')}>
                            Sem atendente ({semAtendente.length})
                        </button>
                        {pessoas.map(x => (
                            <button key={x.id} type="button" className={'fin-pp__tab' + (abaAtiva === 'pessoa:' + x.id ? ' is-active' : '')}
                                onClick={() => trocarAba('pessoa:' + x.id)}>
                                {x.nome} ({x.n})
                            </button>
                        ))}
                    </div>
                )}

                {dados.liberada && (
                    <div className="fin-pp__card mb-3" style={{ padding: 16 }}>
                        {/* Os filtros como na tela do RSVP; os totais do rodapé da planilha embaixo, à direita. */}
                        <div className="fin-pp__filters">
                            <div className="fin-pp__field fin-pp__field--auto" style={{ minWidth: 260, flex: '1 1 260px' }}>
                                <label className="fin-pp__label">Participante</label>
                                <div style={{ position: 'relative' }}>
                                    <FaSearch size={12} style={{ position: 'absolute', left: 10, top: 12, color: '#94a3b8' }} />
                                    <input className="fin-pp__input" style={{ paddingLeft: 30 }} value={busca} placeholder="Buscar pelo nome"
                                        onChange={e => filtrar('busca', e.target.value)} />
                                </div>
                            </div>
                            <SelectOrigem linhas={linhasDaAba} contarEm={semOFiltro('origem')} filtro={filtroOrigem} onFiltrar={v => filtrar('origem', v)} />
                            <SelectRequisicao linhas={linhasDaAba} contarEm={semOFiltro('requisicao')} requisicoes={dados.requisicoes} filtro={filtroRequisicao}
                                onFiltrar={v => filtrar('requisicao', v)} />
                            {/* Abre a linha do filtro por voo; com ele valendo, o botão diz qual e fica em destaque. */}
                            <div className="fin-pp__filters-actions">
                                <button type="button" className={'fin-pp__btn' + (filtroVooAtivo(filtroVoo) ? ' fin-pp__btn--primary' : '')}
                                    aria-expanded={comFiltroVoo} onClick={() => setComFiltroVoo(v => !v)}
                                    title={comFiltroVoo ? 'Fechar o filtro por voo: o que está escolhido continua valendo.' : 'Filtrar pela companhia, pelo número e pela data do voo.'}>
                                    <FaPlane size={12} style={{ marginRight: 6 }} />
                                    {filtroVooAtivo(filtroVoo) ? `Voo: ${resumoFiltroVoo(filtroVoo)}` : 'Filtrar voo'}
                                </button>
                            </div>
                        </div>
                        {comFiltroVoo && <FiltroVoo linhas={linhasDaAba} contarEm={semOFiltro('voo')} filtro={filtroVoo} onFiltrar={v => filtrar('voo', v)} />}
                        <div className="d-flex justify-content-end" style={{ marginTop: 16 }}>
                            <TotaisPlanilha linhas={participantes} tetoTktMedio={dados.tetoTktMedio} tela={tela}
                                sla={dados.familiaSanofi ? { emissao: dados.slaEmissaoDiasUteis, antecedencia: dados.slaAntecedenciaDiasCorridos } : null} />
                        </div>
                    </div>
                )}

                {/* O Consolidado é do evento inteiro, como os totais: o badge no fim da barra abre e fecha. */}
                {dados.liberada && (
                    <div style={{ marginBottom: 14 }}>
                        {/* As chips contam as linhas que passam nos filtros do painel: a escolha lá propaga para cá. */}
                        <ChipsLegenda linhas={semOFiltro('status')} legenda={dados.legenda} filtro={filtro} tela={tela} conferir={recargas}
                            onFiltrar={(r) => { filtrar('status', r); setConsolidado(false); }}
                            direita={<BadgeConsolidado linhas={participantes} tela={tela} ativo={consolidado}
                                onAlternar={() => setConsolidado(c => !c)} />} />
                    </div>
                )}

                {dados.liberada && consolidado && (
                    <div className="fin-pp__card mb-5" style={{ padding: 16 }}>
                        <ConsolidadoPlanilha linhas={participantes} tela={tela} />
                    </div>
                )}

                {/* Marcar para assumir ou desvincular: quem atende o evento, em qualquer aba. */}
                {dados.liberada && !consolidado && selecaoAtendimento && (
                    <div className="fin-pp__card mb-3 d-flex align-items-center gap-3 flex-wrap" style={{ padding: '10px 16px' }}>
                        <span className="fin-pp__cell-muted">
                            {marcadosNaAba.length
                                ? `${marcadosNaAba.length} participante${marcadosNaAba.length !== 1 ? 's' : ''} marcado${marcadosNaAba.length !== 1 ? 's' : ''}`
                                : `Marque os participantes para ${desvincula ? 'desvincular' : 'assumir'}.`}
                        </span>
                        {desvincula ? (
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--danger-ghost"
                                title="Os participantes marcados ficam sem atendente."
                                disabled={!marcadosNaAba.length || processando} onClick={desvincular}>
                                <FaUserMinus size={11} style={{ marginRight: 5 }} /> Desvincular{marcadosNaAba.length ? ` (${marcadosNaAba.length})` : ''}
                            </button>
                        ) : (
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary"
                                title="Você passa a atender os participantes marcados."
                                disabled={!marcadosDeOutros.length || processando} onClick={pedirAssumir}>
                                <FaUserCheck size={11} style={{ marginRight: 5 }} /> Assumir{marcadosDeOutros.length ? ` (${marcadosDeOutros.length})` : ''}
                            </button>
                        )}
                    </div>
                )}

                {dados.liberada && !consolidado && (
                    <div className="fin-pp__card fin-pp__card--clip mb-5">
                        <PlanilhaEmissaoAereo modo="aereo" linhas={linhasDaAba} legenda={dados.legenda} filtro={filtro} filtroRequisicao={filtroRequisicao}
                            filtroOrigem={filtroOrigem} filtroVoo={filtroVoo} filtroAba={abaEscolhida} busca={busca}
                            podeEditar={podeEditarLinha} daPessoa={opera} mostrarAtendente={abaAtiva !== 'minhas'} selecao={selecaoAtendimento}
                            mensagemVazia={abaAtiva === 'minhas' && !minhas.length
                                ? 'Você ainda não atende nenhum participante: marque-os em Todos ou em Sem atendente e clique em Assumir.' : null}
                            processando={processando} baixando={baixando} podeOriginal={dados.podeOriginal}
                            rascunhos={rascunhos} feePadrao={dados.feePadrao?.valor ?? null}
                            onRascunho={rascunhar}
                            onStatus={escolherStatus}
                            onBaixarEditada={(b) => baixar('editada:' + b.id, `${API}/eventoAereoEmissaoBilheteEditado?bilhetes=${b.id}`, 'bilhete-editado.pdf')}
                            onBaixarOriginal={(b) => { setCiente(false); setModal({ tipo: 'original', bilhete: b }); }}
                            onVincular={abreVinculo}
                            onExcluir={(b) => setModal({ tipo: 'excluir', bilhete: b })}
                            onExcluirObservacao={(linha, nota) => alternarExclusao(linha.emissao.id, nota)}
                            onRevisar={(b) => setModal({ tipo: 'revisao', bilhete: b })}
                            // O DBL CHK em massa do cabeçalho: o modal abre com todas as linhas marcadas.
                            onDblCheck={(linhas) => {
                                setForm({ conferir: Object.fromEntries(linhas.map(l => [String(l.emissao.id), true])) });
                                setModal({ tipo: 'dblcheck', linhas });
                            }}
                            // Cancelar é status: vai para o rascunho da linha, com a descrição como motivo.
                            onCancelar={(linha, c) => rascunhar(linha.emissao.id, { rotulo: c.rotulo, observacao: c.descricao, reembolsoPrevisto: c.reembolso })}
                            // `aba`: o botão de DBL CHK do bilhete abre já na dele.
                            onColunas={(linha, aba = 'comunicacao') => {
                                // Reabre com o que está no rascunho da tela; sem ele, com o da linha.
                                const r = rascunhos[linha.emissao.id] ?? {};
                                setForm({
                                    aba,
                                    comunicacao: 'comunicacaoIntermediaria' in r ? r.comunicacaoIntermediaria : (linha.emissao.comunicacaoIntermediaria ?? ''),
                                    assentosIda: 'assentosIda' in r ? r.assentosIda : (linha.emissao.assentosIda ?? null),
                                    assentosVolta: 'assentosVolta' in r ? r.assentosVolta : (linha.emissao.assentosVolta ?? null),
                                    conferir: !!r.conferir,
                                    ...Object.fromEntries(Object.values(CAMPOS_PREVISTOS).flat().map(c => [c, c in r ? r[c] : (linha.emissao[c] ?? null)])),
                                    feeCliente: 'feeCliente' in r ? r.feeCliente : (linha.emissao.feeCliente ?? null),
                                    feeEmTodas: false,
                                    tempoVooIda: 'tempoVooIda' in r ? (r.tempoVooIda ?? '') : (linha.emissao.tempoVooIda ?? ''),
                                    tempoVooRetorno: 'tempoVooRetorno' in r ? (r.tempoVooRetorno ?? '') : (linha.emissao.tempoVooRetorno ?? ''),
                                });
                                setModal({ tipo: 'colunas', linha });
                            }} />
                        {/* As abas da planilha, como as do Excel: o rodapé da tabela, cada uma com o total dela na aba de
                            atendente. Os anos e os tipos que a aba nova oferece são os do evento inteiro. Criar, excluir
                            e dar nome à Todos é de quem salva, e grava no Salvar. */}
                        <AbasDaPlanilha abas={abasNaTela} linhas={participantes} contarEm={linhasDaAba} aba={abaEscolhida}
                            onAba={a => filtrar('aba', a)}
                            onNova={podeSubir ? () => setModal({ tipo: 'novaAba' }) : null}
                            onNomearTodos={podeSubir ? (nome) => setModal({ tipo: 'novaAba', todos: true, nome }) : null}
                            onExcluir={podeSubir ? alternarAba : null} />
                    </div>
                )}

                <div className="row fixoRodape">
                    <div className="col-12 d-flex align-items-center justify-content-end gap-3 flex-wrap">
                        {/* A sugestão de voos do evento, à esquerda dos outros: a tela da malha sem solicitação. */}
                        <Link to={'/cadastroEventoSugestaoAereo/' + idEvento} className="fin-pp__btn fin-pp__btn--pill"
                            title="Voos sugeridos ao RSVP. Salvos, vão no Enviar para o RSVP.">
                            <FaPlane size={12} style={{ marginRight: 6 }} /> Sugestão de Voos{dados.sugestao?.opcoes ? ` (${dados.sugestao.opcoes})` : ''}
                        </Link>
                        <button type="button" className="fin-pp__btn fin-pp__btn--pill" disabled={!dados.liberada || baixando === 'planilha' || processando}
                            onClick={baixarPlanilha}>
                            {baixando === 'planilha' ? <SpinnerBotao /> : <FaFileExcel size={12} style={{ marginRight: 6 }} />} Planilha de Emissão
                        </button>
                        {/* Guarda os rascunhos da tela no rascunho do Aéreo, sem e-mail: o RSVP só vê no Enviar. */}
                        {podeSubir && (
                            <button type="button" className="fin-pp__btn fin-pp__btn--pill"
                                title="Guarda status, motivos, reembolsos e as colunas do lápis no rascunho do Aéreo, sem e-mail: o RSVP só vê no Enviar para o RSVP. Bilhete pronto só é gravado no Enviar. As abas da planilha gravam aqui."
                                disabled={(!linhasParaEnviar.length && !abasAlteradas) || processando} onClick={salvar}>
                                <FaSave size={12} style={{ marginRight: 6 }} /> Salvar
                            </button>
                        )}
                        {/* Um envio só: os rascunhos, as linhas novas salvas e todos os bilhetes prontos. */}
                        {podeSubir && (
                            <button type="button" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--primary"
                                title={sugestaoAEnviar ? 'A sugestão de voos vai junto.' : undefined}
                                disabled={(!aEnviar && !sugestaoAEnviar) || processando} onClick={() => setModal('enviarRsvp')}>
                                <FaPaperPlane size={12} style={{ marginRight: 6 }} /> Enviar para o RSVP{aEnviar ? ` (${aEnviar})` : ''}{sugestaoAEnviar ? ' + sugestão' : ''}
                            </button>
                        )}
                    </div>
                </div>

                {/* Assumir participante de outra pessoa: confirma antes, com quem atendia. Sem descrição: o
                    e-mail a quem atendia diz quem assumiu e quais participantes. */}
                <ConfirmarAcaoModal
                    aberto={modal?.tipo === 'assumir'}
                    titulo="Assumir o atendimento?"
                    subtitulo={deOutraPessoa === marcadosDeOutros.length
                        ? `Você vai assumir o atendimento da emissão de ${deOutraPessoa} participante${deOutraPessoa !== 1 ? 's que estão' : ' que está'} com outra pessoa.`
                        : `Você vai assumir o atendimento da emissão de ${marcadosDeOutros.length} participantes: ${deOutraPessoa} com outra pessoa e ${marcadosDeOutros.length - deOutraPessoa} sem atendente.`}
                    notifica={`${quemAtendia.length > 1 ? quemAtendia.slice(0, -1).map(x => x.nome).join(', ') + ' e ' + quemAtendia[quemAtendia.length - 1].nome : (quemAtendia[0]?.nome ?? '')} ${quemAtendia.length > 1 ? 'recebem' : 'recebe'} um e-mail avisando.`}
                    rotulo="Assumir" icone="aviso" processando={processando}
                    onConfirmar={assumir} onFechar={() => setModal(null)}>
                    <div className="fin-pp__label" style={{ marginBottom: 8 }}>Atendendo agora</div>
                    <div className="d-flex flex-wrap gap-2">
                        {quemAtendia.map(x => (
                            <span key={x.id} className="fin-pp__pill is-info">{x.nome}{deOutraPessoa > 1 ? ` (${x.n})` : ''}</span>
                        ))}
                    </div>
                </ConfirmarAcaoModal>

                <ConfirmarAcaoModal
                    aberto={modal === 'enviarRsvp'}
                    largo={prontosParaGravar.length > 0}
                    titulo="Enviar para o RSVP?"
                    subtitulo={'O que mudou na tela e o que o Aéreo salvou vão para o RSVP, com o e-mail, e os bilhetes prontos são gravados nos participantes.'
                        + (operaTudo ? '' : ' Só os dos participantes que você atende: o rascunho dos outros espera o Enviar de quem os atende.')}
                    notifica="Quem pediu a requisição recebe o e-mail da emissão, com os emitidos e o status dos demais, e os cancelamentos em outro e-mail, em resposta a ele. Os outros RSVP do evento e a caixa do Aéreo vão em cópia."
                    aviso={prontosParaGravar.some(b => (b.divergencias ?? []).length) ? 'Há bilhete com divergência. Confira antes de gravar.' : null}
                    rotulo={`Enviar${aEnviar ? ` (${aEnviar})` : ''}${sugestaoAEnviar ? ' + sugestão' : ''}`} tom="primary" icone="enviar" processando={processando}
                    confirmarPreso={!aEnviar && !sugestaoAEnviar}
                    onConfirmar={enviarParaRsvp} onFechar={() => setModal(null)}>
                    {sugestaoAEnviar && (
                        <div className="fin-pp__notifica" style={{ marginBottom: 12 }}>
                            <FaPlane size={13} style={{ flex: 'none', marginTop: 3 }} />
                            <span>
                                A sugestão de voos vai junto{dados.sugestao?.opcoes ? ` (${dados.sugestao.opcoes} ${dados.sugestao.opcoes === 1 ? 'opção' : 'opções'})` : ''}: o RSVP passa a vê-la e importa para um participante ou para todos.
                            </span>
                        </div>
                    )}
                    {linhasAlteradas > 0 && (
                        <p className="fin-pp__cell-muted" style={{ fontSize: 13, margin: '0 0 8px' }}>
                            {linhasAlteradas === 1 ? '1 linha com alteração.' : `${linhasAlteradas} linhas com alteração.`}
                        </p>
                    )}
                    {prontosParaGravar.length > 0 && (
                        <>
                            <p className="fin-pp__cell-muted" style={{ fontSize: 13, margin: '0 0 8px' }}>
                                Todos os bilhetes prontos vão neste envio. A gravação escreve os voos no cadastro de cada participante e marca Emitido, a não ser que você tenha escolhido outro status para a linha; a escolha do convidado não muda. Confira cada bilhete com a escolha do convidado. Para deixar um de fora, exclua o bilhete.
                            </p>
                            <RevisaoGravacao bilhetes={prontosParaGravar} />
                        </>
                    )}
                    {retidos.length > 0 && (
                        <div style={{ marginTop: 12 }}>
                            <span className="fin-pp__pill is-warn" style={{ whiteSpace: 'normal' }}>
                                Fica fora deste envio: o bilhete de {nomesRetidos.join(', ')}. O convidado trocou o voo depois da requisição, e o bilhete espera o RSVP reenviar a linha.
                            </span>
                        </div>
                    )}
                </ConfirmarAcaoModal>

                <ConfirmarAcaoModal
                    aberto={modal === 'subir'}
                    titulo={`Subir ${arquivos.length} bilhete${arquivos.length !== 1 ? 's' : ''}?`}
                    subtitulo="Cada PDF é lido e casado com o participante solicitado. Ao terminar, a cópia editada de cada bilhete é baixada."
                    rotulo="Subir" tom="primary" icone="enviar" processando={processando}
                    onConfirmar={subir} onFechar={() => setModal(null)}
                />
                <ConfirmarAcaoModal
                    aberto={modal?.tipo === 'excluir'}
                    titulo="Excluir este bilhete?"
                    subtitulo="O PDF subido e a leitura dele são apagados. A exclusão fica registrada na auditoria."
                    rotulo="Excluir" tom="danger" icone="danger" processando={processando}
                    onConfirmar={() => post('/eventoAereoEmissaoBilheteExcluir', { bilhete: modal.bilhete.id }, 'Bilhete excluído')}
                    onFechar={() => setModal(null)}
                />
                <ConfirmarAcaoModal
                    aberto={modal?.tipo === 'excluirTodos'}
                    titulo={soltos.length === 1 ? 'Excluir o bilhete sem participante?' : `Excluir os ${soltos.length} bilhetes sem participante?`}
                    subtitulo="Os PDFs subidos e a leitura deles são apagados. A exclusão fica registrada na auditoria."
                    rotulo="Excluir todos" tom="danger" icone="danger" processando={processando}
                    onConfirmar={() => post('/eventoAereoEmissaoBilheteExcluir', { bilhetes: soltos.map(s => s.id) },
                        soltos.length === 1 ? 'Bilhete excluído' : `${soltos.length} bilhetes excluídos`)}
                    onFechar={() => setModal(null)}
                />
                <ConfirmarAcaoModal
                    aberto={modal?.tipo === 'original'}
                    titulo="Baixar a versão original?"
                    subtitulo="Esta versão contém dados sigilosos: os valores faturados pela Access."
                    aviso="Não envie, anexe nem compartilhe este arquivo. Para qualquer outro uso, baixe a versão editada."
                    rotulo="Baixar original" tom="danger" icone="aviso" processando={processando}
                    confirmarPreso={!ciente}
                    onConfirmar={baixarOriginal}
                    onFechar={() => { setModal(null); setCiente(false); }}>
                    <FinCheck checked={ciente} onChange={e => setCiente(e.target.checked)}
                        label="Estou ciente de que esta versão contém dados sigilosos e é de uso interno." />
                </ConfirmarAcaoModal>
                <ConfirmarAcaoModal
                    aberto={modal?.tipo === 'vincular'}
                    titulo={vinculoCancelado ? 'Vincular Cancelado' : 'Vincular o bilhete ao participante'}
                    subtitulo={modal?.bilhete?.dados?.passageiro ? `Passageiro no bilhete: ${modal.bilhete.dados.passageiro}` : undefined}
                    // O Vincular Cancelado em vermelho, a cor da linha cancelada: o ícone, o botão e a escolha da linha.
                    rotulo="Vincular" tom={vinculoCancelado ? 'danger' : 'primary'} icone="ok" processando={processando}
                    confirmarPreso={!form.emissao || !form.trecho || (vinculoCancelado && typeof form.novaLinha !== 'boolean')}
                    // Atribuir o bilhete tira o status que estava em rascunho na linha: com o bilhete
                    // fechando a emissão, o que aparece é o Emitido, e o Aéreo troca se quiser. Na linha nova do
                    // Vincular Cancelado o bilhete não fica na cancelada, e o rascunho dela fica como está.
                    onConfirmar={() => post('/eventoAereoEmissaoBilheteVincular',
                        { bilhete: modal.bilhete.id, emissao: form.emissao, trecho: form.trecho, novaLinha: vinculoCancelado && form.novaLinha === true },
                        'Bilhete vinculado', () => { if (!(vinculoCancelado && form.novaLinha)) semStatusNoRascunho(form.emissao); })}
                    onFechar={() => setModal(null)}>
                    <div className="fin-pp__filters">
                        <FinField label="Participante" required full>
                            {/* O cancelado também: é o Vincular Cancelado, que pergunta se o bilhete vai numa linha nova ou na mesma. */}
                            <ReactSelect placeholder="Escolha"
                                options={participantes.filter(p => p.emissao).map(p => ({ value: p.emissao.id, label: p.nome + (p.emissao.situacao === 'cancelado' ? ' (cancelado)' : '') }))}
                                value={form.emissao ? { value: form.emissao } : null}
                                onChange={e => setForm(f => ({ ...f, emissao: e ? e.value : '', novaLinha: null }))} />
                        </FinField>
                        <FinField label="Trecho" required full>
                            <ReactSelect placeholder="Escolha" options={opcoesSelect(TRECHOS)}
                                value={form.trecho ? { value: form.trecho } : null}
                                onChange={e => setForm(f => ({ ...f, trecho: e ? e.value : '' }))} />
                        </FinField>
                        {vinculoCancelado && (
                            <FinField label="Linha do bilhete" required full>
                                <FinChecks inline className="is-danger">
                                    {[[true, 'Nova linha', 'linha-nova'], [false, 'Na mesma linha', 'linha-mesma']].map(([valor, rotulo, id]) => (
                                        <FinCheck key={id} type="radio" name="linhaDoBilhete" id={id} label={rotulo}
                                            checked={form.novaLinha === valor} onChange={() => setForm(f => ({ ...f, novaLinha: valor }))} />
                                    ))}
                                </FinChecks>
                                <p className="fin-pp__cell-muted" style={{ margin: 0, fontSize: 12 }}>
                                    {form.novaLinha === true
                                        ? <>Mantém a linha cancelada e criará outra com o bilhete novo.<br />Herda voos pedidos, data de aprovação e atendente.</>
                                        : form.novaLinha === false
                                            ? 'O bilhete será vinculado na mesma linha cancelada.'
                                            : 'A linha deste participante está cancelada: escolha onde o bilhete fica.'}
                                </p>
                            </FinField>
                        )}
                    </div>
                </ConfirmarAcaoModal>
                {/* Status que não é "a emitir": pede o motivo, que volta para o RSVP na tela dele. Fica
                    no rascunho até o Salvar ou o Enviar para o RSVP. */}
                {(() => {
                    // Na aprovação de custos, o motivo pede a reserva de cada lado sem bilhete (`ladosDaReserva`): ela entra
                    // no total e no TKT médio até o bilhete chegar. Obrigatória, como o motivo.
                    const lados = modal?.tipo === 'status' ? ladosDaReserva(modal.linha, modal.rotulo) : [];
                    const campos = lados.flatMap(lado => CAMPOS_PREVISTOS[lado]);
                    const faltaReserva = campos.some(c => form[c] === null || form[c] === undefined || form[c] === '');
                    const reserva = (campo, rotulo) => (
                        <FinField key={campo} label={rotulo} required>
                            <FinValor allowNegative={false} moeda="real" decimalScale={2} fixedDecimalScale={false} placeholder="R$ 0,00"
                                value={form[campo] ?? ''}
                                onValueChange={({ floatValue }) => setForm(f => ({ ...f, [campo]: floatValue ?? null }))} />
                        </FinField>
                    );
                    return (
                        <ConfirmarAcaoModal
                            aberto={modal?.tipo === 'status'}
                            titulo={modal?.linha ? `${modal.linha.nome}` : ''}
                            subtitulo="O motivo de não emitir vai para o RSVP no Enviar para o RSVP, na coluna Observação da tela dele."
                            rotulo="Aplicar" tom="primary" icone="ok" processando={processando}
                            confirmarPreso={!String(form.observacao ?? '').trim() || faltaReserva}
                            onConfirmar={() => {
                                rascunhar(modal.linha.emissao.id, { rotulo: modal.rotulo, observacao: form.observacao,
                                    ...Object.fromEntries(campos.map(c => [c, form[c]])) });
                                setModal(null);
                            }}
                            onFechar={() => setModal(null)}>
                            {modal?.tipo === 'status' && (
                                <div style={{ marginBottom: 12 }}>
                                    <span className="fin-pp__cell-muted" style={{ marginRight: 8 }}>Novo status:</span>
                                    <PillLegenda rotulo={modal.rotulo} legenda={dados.legenda} />
                                </div>
                            )}
                            <FinField label="Motivo" required full>
                                <FinTextarea rows={4} autoFocus value={form.observacao ?? ''}
                                    placeholder="Por que este participante não foi emitido" onChange={e => setForm(f => ({ ...f, observacao: e.target.value }))} />
                            </FinField>
                            {lados.length > 0 && (
                                <>
                                    <div className="fin-pp__cell-muted" style={{ fontSize: 12, margin: '14px 0 8px' }}>
                                        Valores da reserva: entram no total e no TKT médio até o bilhete chegar. A tarifa é a do bilhete, com o RAV/FEE quando houver.
                                    </div>
                                    <div className="fin-pp__filters">
                                        {lados.map(lado => (
                                            <React.Fragment key={lado}>
                                                {reserva(CAMPOS_PREVISTOS[lado][0], lado === 'ida' ? 'Tarifa ida' : 'Tarifa volta')}
                                                {reserva(CAMPOS_PREVISTOS[lado][1], lado === 'ida' ? 'Taxas ida' : 'Taxas volta')}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </>
                            )}
                        </ConfirmarAcaoModal>
                    );
                })()}
                {/* Colunas editáveis (o lápis da linha): a Comunicação Intermediária, os assentos e o DBL CHECK.
                    O Aplicar põe no rascunho da linha, como o status; o Salvar guarda e o Enviar para o RSVP
                    manda, sem e-mail por elas. Como o status, o RSVP vê no Enviar. Na planilha, a comunicação
                    vai para a COMUNICAÇÃO INTERMEDIADORA, os assentos para ASSENTOS IDA e VOLTA, e cada
                    conferência, com a data e as iniciais de quem marcou ("28/09-jo"), para uma coluna DBL CHECK. */}
                <ConfirmarAcaoModal
                    aberto={modal?.tipo === 'colunas'}
                    titulo={modal?.linha ? `Colunas editáveis · ${modal.linha.nome}` : ''}
                    subtitulo="Fica na tela até o Salvar ou o Enviar para o RSVP, no rodapé. Cada uma vai para a coluna dela na planilha de emissão."
                    // Largo: as seis abas cabem numa linha, sem a barra de rolagem.
                    rotulo="Aplicar" tom="primary" icone="ok" largo
                    confirmarPreso={modal?.tipo === 'colunas' && !(tempoDeVooValido(form.tempoVooIda) && tempoDeVooValido(form.tempoVooRetorno))}
                    onConfirmar={() => { rascunharColunas(modal.linha, form); setModal(null); }}
                    onFechar={() => setModal(null)}>
                    {modal?.tipo === 'colunas' && <ColunasEditaveis linha={modal.linha} form={form} setForm={setForm} reserva={reservaDoLapis(modal.linha)}
                        feePadrao={dados.feePadrao} />}
                </ConfirmarAcaoModal>
                {/* A revisão pelo clique no bilhete (o selo, o trecho, o número ou as divergências): a mesma do
                    Enviar para o RSVP, só com o participante dele e sem o Enviar. A linha do campo divergente sai marcada. */}
                <ConfirmarAcaoModal
                    aberto={modal?.tipo === 'revisao'}
                    titulo="Revisão da gravação"
                    subtitulo={donoDaRevisao?.nome}
                    rotuloFechar="Fechar" icone="aviso" largo
                    onFechar={() => setModal(null)}>
                    {modal?.tipo === 'revisao' && <RevisaoGravacao bilhetes={bilhetesDaRevisao} />}
                </ConfirmarAcaoModal>
                {/* DBL CHK em massa (o botão do cabeçalho dos bilhetes, com o filtro de voo): cada linha do filtro
                    com a conferência que ela ganha, todas marcadas. O Aplicar marca ou desmarca a conferência no
                    rascunho de cada uma, como o lápis; o Salvar grava com a data e quem conferiu. */}
                <ConfirmarAcaoModal
                    aberto={modal?.tipo === 'dblcheck'}
                    titulo="DBL CHK em massa"
                    subtitulo={`Voo ${resumoFiltroVoo(filtroVoo)} · ${modal?.linhas?.length ?? 0} participante${modal?.linhas?.length === 1 ? '' : 's'}. Fica na tela até o Salvar ou o Enviar para o RSVP, no rodapé.`}
                    rotulo="Aplicar" tom="primary" icone="ok" largo
                    onConfirmar={() => { rascunharConferencias(form.conferir ?? {}); setModal(null); }}
                    onFechar={() => setModal(null)}>
                    {modal?.tipo === 'dblcheck' && (
                        <div className="d-flex flex-column">
                            {/* Marca ou desmarca todas de uma vez; fica marcado só com todas marcadas. */}
                            <div style={{ paddingBottom: 8, borderBottom: '1px solid var(--fin-bd)' }}>
                                <FinCheck checked={modal.linhas.every(l => !!form.conferir?.[String(l.emissao.id)])}
                                    label={`Selecionar todos (${modal.linhas.filter(l => form.conferir?.[String(l.emissao.id)]).length} de ${modal.linhas.length})`}
                                    onChange={ev => {
                                        const marcada = ev.target.checked;
                                        setForm(f => ({ ...f, conferir: Object.fromEntries(modal.linhas.map(l => [String(l.emissao.id), marcada])) }));
                                    }} />
                            </div>
                            {modal.linhas.map((l, n) => {
                                const id = String(l.emissao.id);
                                // O LOC de cada lado gravado e o dos bilhetes da linha: o que se confere na companhia.
                                const locs = [...new Set([l.emitidoIda?.localizador, l.emitidoRetorno?.localizador,
                                    ...(l.emissao.bilhetes ?? []).map(b => b.dados?.localizador)].filter(Boolean))];
                                return (
                                    <div key={id} style={{ padding: '8px 0', borderTop: n ? '1px solid var(--fin-bd)' : undefined }}>
                                        <div className="d-flex justify-content-between gap-3">
                                            <span className="fin-pp__cell-strong">{l.nome}</span>
                                            <span className="fin-pp__cell-muted" style={{ fontSize: 12 }}>{locs.length ? `LOC ${locs.join(' · ')}` : 'Sem LOC'}</span>
                                        </div>
                                        <FinCheck checked={!!form.conferir?.[id]} label={`${(l.emissao.dblCheck ?? []).length + 1}ª conferência`}
                                            onChange={ev => { const marcada = ev.target.checked; setForm(f => ({ ...f, conferir: { ...f.conferir, [id]: marcada } })); }} />
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </ConfirmarAcaoModal>
                {/* A aba nova da planilha: o Aplicar a põe no rascunho da tela, e ela grava no Salvar. */}
                {modal?.tipo === 'novaAba' && (
                    <NovaAba linhas={participantes} abas={abasNaTela.filter(a => !a.excluir)} todos={!!modal.todos} nomeAtual={modal.nome}
                        onAplicar={modal.todos ? nomearTodos : aplicarAba} onFechar={() => setModal(null)} />
                )}
                {atendimento.modal}
            </div>
        </ErpTemplate>
    );
}
